import React, {useEffect, useState} from "react";
import {useNavigate, useParams} from "react-router-dom";
import {programsService} from "../../../services/programsService/programsService";
import {PageErrorMessage} from "../../../components/PageErrorMessage";
import Loader from "../../../components/common/Loader";
import TextEditorContent from "../../../components/TextEditorContent";
import ProgramMasterclassList from "./ProgramMasterclassList";

const SpeakerProgramDetails = () => {
    const [isLoading, setIsLoading] = useState(true);
    const [programDetails, setProgramDetails] = useState(null);
    const { id } = useParams();
    const navigate = useNavigate();
    const [error, setError] = useState(null);

    const programDetailsData = async () => {
        setIsLoading(true);
        try {
            await programsService.getSpeakerSingleProgramData(id).then((response) => {
                setProgramDetails(response?.data);
            });
            setIsLoading(false);
        } catch (error) {
            setError({
                statusCode: error.response.status,
                message: error.response.data.message,
            });
            setIsLoading(false);
        }
    };

    // useEffect of call all api function
    useEffect(() => {
        programDetailsData();
    }, [id]);

    const firstUncompletedMasterClass = programDetails?.master_classes.find(
        masterClass => masterClass.is_completed === false && masterClass.first_lesson !== null
    ) || null;

    const handleBeginProgram = () => {
        if (firstUncompletedMasterClass !== null) {
            navigate('/lessons/' + firstUncompletedMasterClass.first_lesson);
        }
    };

    if (error) {
        return <PageErrorMessage
            error={error}
            entityTitle="Program"
        />;
    }

    return (
        <>
            {isLoading ? (
                <>
                    <Loader />
                </>
            ) : (
                <>
                    <div className="container-fluid">
                        <div className="row mb-5 py-5 px-4 program__content">
                            <div className="col-md-6 text-center">
                                <div className="program__image">
                                    <img
                                        src={programDetails?.cover_image}
                                        alt={programDetails?.title}
                                        className="img-fluid"
                                    />
                                </div>
                            </div>

                            <div className="col-md-6 mb-4 mb-md-0">
                                <h1>{programDetails?.name}</h1>
                                <TextEditorContent
                                    text={programDetails?.description}
                                />
                                <div className="d-flex mt-3">
                                    <button
                                        className="btn btn-primary-info me-2"
                                        disabled={firstUncompletedMasterClass === null}
                                        onClick={handleBeginProgram}
                                    >
                                        Begin
                                    </button>
                                </div>
                                <div className="d-flex align-center mt-3">
                                    <div className="fs-6 lh-base fw-bolder">
                                        Credit Hours: {programDetails?.credit_hours}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <ProgramMasterclassList
                            masterClasses={programDetails?.master_classes}
                        />
                    </div>
                </>
            )}
        </>
    );
};

export default SpeakerProgramDetails;